export default {
  namespaced: true,
  state: {
    userImage: '',
  },
  mutations: {
    setUserImage(state, payload) {
      state.userImage = payload
    },
  },
}
